import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFieldArray } from "react-hook-form";
import {
  HubButton,
  HubHookFormInput,
  HubHookFormSelect,
} from "../../../components";
import { PostFoundryTable } from "../../../tables";
import { StyledHubCardStack } from "../styles";
import { useHighlightableField } from "../../../hooks";

const gap = "10px";

const grindGates = [
  { id: 1, label: "Flush" },
  { id: 2, label: "Witness" },
];

const PartPostFoundry = ({ basePath, routeOps }) => {
  const routingPath = `${basePath}.routing`;
  const configPath = `${basePath}.config`;
  const notesPath = `${basePath}.notes`;

  const { HighlightMenu, getFieldProps } = useHighlightableField();
  const fieldArrayOptions = useFieldArray({ name: routingPath });
  const { fields, append, remove, move } = fieldArrayOptions;

  const handleAdd = () => {
    const newItem = {
      stationId: null,
      leadTime: 1440,
      cycleTime: 0,
      notes: "",
      config: { isOutside: false },
    };

    if (routeOps?.add)
      routeOps.add(basePath, fields?.length, () => append(newItem));
    else append(newItem);
  };

  const tableMove = (start, end) => {
    if (routeOps?.move) routeOps.move(basePath, start, end, move);
    else move(start, end);
  };

  const tableRemove = (idx) => {
    if (routeOps?.remove) routeOps.remove(basePath, idx, remove);
    else remove(idx);
  };

  return (
    <StyledHubCardStack gap="25px">
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Post Foundry Routing</Typography>
        <PostFoundryTable
          {...fieldArrayOptions}
          move={tableMove}
          remove={tableRemove}
          basePath={routingPath}
          getFieldProps={getFieldProps}
        />
        <HubButton
          label="Add Routing"
          variant="text"
          sx={{ fontSize: 10, ml: "auto", mb: -5 }}
          onClick={handleAdd}
        />
      </Stack>

      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Post Foundry Details</Typography>
        <Stack direction="row" gap={gap}>
          <HubHookFormInput
            name={`${configPath}.gates`}
            label="Gates"
            placeholder="ex. 4"
            {...getFieldProps(`${configPath}.gates`)}
          />
          <HubHookFormSelect
            name={`${configPath}.flushWitness`}
            label="Grind Gate"
            options={grindGates}
            useDefault={false}
            allowNull
            {...getFieldProps(`${configPath}.flushWitness`)}
          />
        </Stack>
      </Stack>

      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Post Foundry Notes</Typography>
        <HubHookFormInput
          name={notesPath}
          label="Special Instructions"
          placeholder="Post Foundry notes..."
          rows={5}
          multiline
          {...getFieldProps(notesPath)}
        />
      </Stack>

      {HighlightMenu}
    </StyledHubCardStack>
  );
};

export default PartPostFoundry;
